import { Component } from '@angular/core';
import { AppRoutes } from 'src/app/core/models/routes.model';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent {
  /** La dichiarazione deve essere raggiungibile da ogni pagina del servizio. */
  readonly accessibilityRoute = ['/', AppRoutes.MAIN_ROUTE, AppRoutes.ACCESSIBILITY];
  readonly currentYear = new Date().getFullYear();
}
